export default {
  namespaced: true,
  state: {
    //手机号
    phone: "",
    //重定向到哪个网址
    redirect: "",
    //从哪个平台过来
    platform: "",
    //平台角色
    role: "",
    //登录医生姓名
    name: "",
    //头像
    avatar: "",
    //token
    common_token: "",
    //登录时后台返回do
    login_todo: "",
  },
  mutations: {
    SET_DATA(state, payload) {
      for (let key in payload) {
        state[key] = payload[key];
      }
    },
    CLEAR_DATA(state) {
      state.phone = "";
      state.avatar = "";
      state.name = "";
      state.login_todo = "";
      state.common_token = "";
    },
  },
  actions: {},
};
